import React from "react";
import './component.css';
import soldFrame from '../assets/soldInfo.png'; 

type Props = { children: React.ReactNode; className?: string };

export default function SoldInfoFrame({ children, className = "" }: Props) {
  return (
    <div
      className={`content-frame ${className}`}
      style={{ backgroundImage: `url(${soldFrame})` }}
    >
      <div className="content-frame__inner">
        {children}
      </div>
    </div>
  );
}
